import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stat-value" }
const _hoisted_2 = { class: "stat-unit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stat", _ctx.statType])
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.value), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.unit), 1)
  ], 2))
}